import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RequiredDocumentUpload from "./component";
import { diyPaymentApprovalProcess, dmsLogin, dowloadConsentLetter, fetchRequiredDocumentList, uploadDocumentToDMS, verifyDocumentUpload, verifyEkycDocument } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        dmsLoginData,
        postTokenDocuments,
        inspectionResponse
    }
}) => ({
    dmsLoginData,
    postTokenDocuments,
    inspectionResponse
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    uploadDocumentToDMSConnect: uploadDocumentToDMS,
    dowloadConsentLetterConnect: dowloadConsentLetter,
    dmsLoginConnect: dmsLogin,
    fetchRequiredDocumentListConnect: fetchRequiredDocumentList,
    verifyEkycDocumentConnect: verifyEkycDocument,
    diyPaymentApprovalProcessConnect: diyPaymentApprovalProcess,
    verifyDocumentUploadConnect: verifyDocumentUpload
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RequiredDocumentUpload);
